import {
  CardProps,
  MenuItem,
  typeAlert,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { TFunction } from "i18next";

export const downData: CardProps[] = [
  {
    id: "1",
    numericalTitle: "0",
    title: "Cotizaciones",
  },
  {
    id: "2",
    numericalTitle: "0",
    title: "Pólizas Finalizadas",
  },
];

export const seriesFn = (tl: TFunction) => {
  const series: any[] = [
    {
      color: "#3A56A1",
      data: [],
      name: tl(`salesReport.barChart.series.name1`), //EMITIDAS
    },
    {
      color: "#A8B5D6",
      data: [],
      name: tl(`salesReport.barChart.series.name2`), // COTIZADAS
    },
  ];
  return series;
};

export const categories: any = [];

export const dataChip: MenuItem[] = [
  {
    active: true,
    id: "1",
    name: "Mes actual",
    code: "currentMonth",
  },
  {
    active: false,
    id: "2",
    name: "Mes anterior",
    code: "prevMonth",
  },
  {
    active: false,
    id: "3",
    name: "Trimestre actual",
    code: "currentQuarter",
  },
  {
    active: false,
    id: "4",
    name: "Trimestre anterior",
    code: "prevQuarter",
  },
  {
    active: false,
    id: "5",
    name: "Semestre actual",
    code: "currentSemester",
  },
];

export interface ReportState {
  enable: boolean;
  page: number;
  limit: number;
  reportCard: CardProps[];
  reportTrigger: boolean;
  bodyReport: any;
  dateRange: string;
}

export interface ToastState {
  show: boolean;
  type: typeAlert;
  message: string;
}

// {
//   "id": "quotePolices",
//   "name": "Cotizaciones / Ventas",
//   "icon": "icons.Shield",
//   "active": true,
//   "route": "/report-quote-sales/",
//   "divider": false
//
// },
